<template>
  <div>
    <PopularService
      v-for="(service, index) in popularServices"
      :key="index"
      :pop_name="service.name"
      :pop_id="service.id"
      :pop_price="service.price"
      :pop_dur="service.duration"
      :pop="service"
    ></PopularService>
  <div v-if="!popularServices">
    Нет популярных сервисов
  </div>
  </div>
</template>
<script>
import PopularService from "@/components/PopularService/PopularService.vue";
import { mapGetters, mapState, mapActions } from "vuex";
export default {
  name: "PopularServices",
  components: {
    PopularService
  },

  computed: {
    ...mapState("client", ["currentSalonId"]),
    ...mapGetters("salons", ["getPopularServices"]),

    popularServices() {
      const temp = this.getPopularServices(this.currentSalonId);
      // console.log(temp);
      return temp;
    }
  },

  methods: {
    ...mapActions("salons", ["fetchSalonPopularServices"])
  },

  mounted() {
    this.fetchSalonPopularServices(this.currentSalonId);
  }
};
</script>
